import type { Editor } from "@tiptap/core"

import type { DiagramEditorSession } from "../types"
import {
  buildDiagramNodeAttrs,
  type DiagramSavePayload,
} from "./diagramNodeAttrs"
import { insertBlockContentAndPlaceCaretAfter } from "./placeCaretAfterBlockInsert"

const placeCaretAfterPos = (editor: Editor, pos: number) => {
  const node = editor.state.doc.nodeAt(pos)
  if (!node) return

  const afterPos = pos + node.nodeSize
  editor
    .chain()
    .focus()
    .command(({ chain, state }) => {
      const $after = state.doc.resolve(afterPos)
      if ($after.nodeAfter?.isTextblock) {
        return chain().setTextSelection(afterPos + 1).run()
      }
      return chain()
        .insertContentAt(afterPos, { type: "paragraph" })
        .setTextSelection(afterPos + 1)
        .run()
    })
    .run()
}

export const saveDiagramToEditor = (
  editor: Editor,
  payload: DiagramSavePayload,
  session: DiagramEditorSession | null
) => {
  const attrs = buildDiagramNodeAttrs(payload)

  if (session?.mode === "edit") {
    editor
      .chain()
      .focus()
      .setNodeSelection(session.pos)
      .updateAttributes("diagram", attrs)
      .run()
    placeCaretAfterPos(editor, session.pos)
    return
  }

  insertBlockContentAndPlaceCaretAfter(editor, {
    type: "diagram",
    attrs,
  })
}
